export default function saveToLocalStorage<T>(token: string, obj: T): void {
    const json = JSON.stringify(obj);
    localStorage.setItem(token, json);
}
